import { Info } from "lucide-react";
import { PageHero } from "../components/common/SectionHeading";
import { PricingCards } from "../components/sections/PricingCards";
import { CtaBand } from "../components/sections/CtaBand";
import { usePageTitle } from "../lib/usePageTitle";

export default function PricingPage() {
  usePageTitle("Pricing");
  return (
    <>
      <PageHero label="Pricing" title="Simple plans for every vehicle." body="Choose the plan that fits how you drive. Final pricing will be announced at launch — register your interest and we'll reach out." />
      <section className="section-pad !pt-16">
        <div className="container-x">
          <PricingCards />
          <p data-testid="pricing-note" className="mt-10 flex items-start gap-3 text-sm text-slate-500">
            <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
            Prices shown are placeholders and will be confirmed before launch. Online payment is not available yet.
          </p>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
